export default __webpack_public_path__ + "static/media/facebook.73937baf.png";